React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_popover')

module.exports = class extends React.Component
  render: t.renderable ->
    t.div '.u-clearfix', =>
      t.a '.dash-clear-filter',
        href: "#"
        onClick: =>
          @props.onClick()
      , =>
        t.format 'deselect'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/filters/popover-button-component.coffee